import { render } from "./RoleEditIframe.vue?vue&type=template&id=48856cdc&ts=true"
import script from "./RoleEditIframe.ts?vue&type=script&lang=ts&external"
export * from "./RoleEditIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__